"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.upload.mode.title': 'Wybierz metodę wprowadzania danych',
    'trainer.upload.mode.file': 'Prześlij plik CSV',
    'trainer.upload.mode.manual': 'Ręczne wprowadzanie',
    'trainer.upload.mode.pdf': 'Przetwarzanie PDF',
    'trainer.upload.mode.file.description': 'Prześlij wstępnie sformatowany plik CSV z danymi treningowymi',
    'trainer.upload.mode.manual.description': 'Twórz dane treningowe używając przyjaznego interfejsu formularza',
    'trainer.upload.mode.pdf.description': 'Prześlij PDF aby automatycznie wyekstraktować i wygenerować dane treningowe z rozdziałów',
    'trainer.upload.title': 'Wgraj Dane Treningowe (CSV)',
    'trainer.upload.format.required': 'Wymagany Format CSV:',
    'trainer.upload.format.input': 'Tekst zapytania/promptu',
    'trainer.upload.format.output': 'Oczekiwana odpowiedź/wynik',
    'trainer.upload.format.category': 'Kategoria klasyfikacji',
    'trainer.upload.format.optional': 'opcjonalny',
    'trainer.upload.format.metadata': 'Dodatkowe kolumny metadanych są obsługiwane i zostają zachowane.',
    'trainer.upload.processing': 'Przetwarzanie pliku...',
    'trainer.upload.select': 'Wybierz Plik CSV',
    'trainer.upload.file.info': 'Informacje o Pliku',
    'trainer.upload.file.name': 'Nazwa pliku:',
    'trainer.upload.file.size': 'Rozmiar:',
    'trainer.upload.file.type': 'Typ:',
    'trainer.upload.data.analysis': 'Analiza Danych',
    'trainer.upload.stats.samples': 'Próbki Treningowe',
    'trainer.upload.stats.input.length': 'Średnia Długość Wejścia',
    'trainer.upload.stats.output.length': 'Średnia Długość Wyjścia',
    'trainer.upload.stats.categories': 'Kategorie',
    'trainer.upload.stats.quality': 'Ocena Jakości',
    'trainer.upload.categories.found': 'Znalezione kategorie:',
    'trainer.upload.preview': 'Podgląd Danych (Pierwsze 3 wiersze)',
    'trainer.upload.preview.input': 'Wejście',
    'trainer.upload.preview.output': 'Wyjście',
    'trainer.upload.preview.category': 'Kategoria',
    'trainer.upload.manual.title': 'Twórz Dane Treningowe Manualnie',
    'trainer.upload.manual.description': 'Dodawaj przykłady treningowe jeden po drugim używając formularza poniżej. Każdy przykład powinien zawierać prompt wejściowy i oczekiwaną odpowiedź wyjściową.',
    'trainer.upload.manual.input': 'Wejście (Prompt)',
    'trainer.upload.manual.input.placeholder': 'Wprowadź prompt lub pytanie...',
    'trainer.upload.manual.output': 'Wyjście (Odpowiedź)',
    'trainer.upload.manual.output.placeholder': 'Wprowadź oczekiwaną odpowiedź...',
    'trainer.upload.manual.category': 'Kategoria (Opcjonalna)',
    'trainer.upload.manual.category.placeholder': 'Wprowadź etykietę kategorii...',
    'trainer.upload.manual.add': 'Dodaj Wpis',
    'trainer.upload.manual.update': 'Zaktualizuj Wpis',
    'trainer.upload.manual.cancel': 'Anuluj Edycję',
    'trainer.upload.manual.edit': 'Edytuj',
    'trainer.upload.manual.delete': 'Usuń',
    'trainer.upload.manual.list.title': 'Wpisy Danych Treningowych',
    'trainer.upload.manual.export': 'Eksportuj jako CSV',
    'trainer.upload.manual.validation.required': 'Pola wejścia i wyjścia są wymagane',
    'trainer.upload.manual.export.empty': 'Brak danych treningowych do eksportu',
    'trainer.upload.pdf.title': 'Generowanie danych treningowych PDF',
    'trainer.upload.pdf.description': 'Prześlij dokument PDF aby automatycznie wyekstraktować tekst i wygenerować dane treningowe zorganizowane według rozdziałów.',
    'trainer.upload.pdf.upload.title': 'Prześlij dokument PDF',
    'trainer.upload.pdf.select': 'Wybierz plik PDF',
    'trainer.upload.pdf.processing': 'Przetwarzanie PDF...',
    'trainer.upload.pdf.extracting': 'Wyodrębnianie rozdziałów...',
    'trainer.upload.pdf.context.label': 'Kontekst (Opcjonalny)',
    'trainer.upload.pdf.context.placeholder': 'Podaj dodatkowy kontekst dotyczący zawartości dokumentu aby poprawić jakość danych treningowych...',
    'trainer.upload.pdf.extract.button': 'Wyodrębnij rozdziały',
    'trainer.upload.pdf.chapters.title': 'Wyodrębnione rozdziały',
    'trainer.upload.pdf.chapters.select': 'Wybierz rozdziały do przetworzenia:',
    'trainer.upload.pdf.chapters.selectall': 'Zaznacz wszystkie',
    'trainer.upload.pdf.chapters.deselectall': 'Odznacz wszystkie',
    'trainer.upload.pdf.chapters.generate.button': 'Generuj dane treningowe z wybranych rozdziałów',
    'trainer.upload.pdf.chapters.generating': 'Generowanie danych treningowych...',
    'trainer.upload.pdf.chapters.preview': 'Podgląd:',
    'trainer.upload.pdf.chapters.words': 'słów',
    'trainer.upload.pdf.file.info': 'Informacje o PDF',
    'trainer.upload.pdf.file.name': 'Nazwa pliku:',
    'trainer.upload.pdf.file.size': 'Rozmiar:',
    'trainer.upload.pdf.file.pages': 'Strony:',
    'trainer.upload.pdf.success': 'Dane treningowe wygenerowane pomyślnie!',
    'trainer.upload.pdf.error': 'Błąd podczas przetwarzania PDF. Spróbuj ponownie.',
    'trainer.upload.pdf.error.extraction': 'Błąd podczas wyodrębniania rozdziałów z PDF',
    'trainer.upload.pdf.error.generation': 'Błąd podczas generowania danych treningowych',
    'trainer.upload.pdf.error.nofile': 'Proszę wybrać plik PDF',
    'trainer.upload.pdf.error.nochapters': 'Proszę wybrać co najmniej jeden rozdział',
};
